import type { LWApiPublicAssetStatusT } from '@liquidweb-dev/club-sauce/public/asset';
import type { AssetDetails } from 'modules/queries/asset/useDetails';

export type StatusData = {
	level: 'on' | 'activity' | 'problem' | 'off';
	label:
		| 'New'
		| 'Activating'
		| 'Active'
		| 'Running'
		| 'Stopped'
		| 'Starting'
		| 'Stopping'
		| 'Shutting down'
		| 'Rebooting'
		| 'Resetting'
		| 'Terminating'
		| 'Error';
};

export interface ServerStatusMap {
	new: StatusData;
	activating: StatusData;
	running: StatusData;
	stopped: StatusData;
	starting: StatusData;
	stopping: StatusData;
	shuttingDown: StatusData;
	rebooting: StatusData;
	resetting: StatusData;
	terminating: StatusData;
	active: StatusData;
	error: StatusData;
}

const serverStatusMap: ServerStatusMap = {
	running: { level: 'on', label: 'Running' },
	active: { level: 'on', label: 'Active' },

	activating: { level: 'activity', label: 'Activating' },
	starting: { level: 'activity', label: 'Starting' },
	stopping: { level: 'activity', label: 'Stopping' },
	shuttingDown: { level: 'activity', label: 'Shutting down' },
	rebooting: { level: 'activity', label: 'Rebooting' },
	resetting: { level: 'activity', label: 'Resetting' },
	terminating: { level: 'activity', label: 'Terminating' },
	new: { level: 'activity', label: 'New' },

	stopped: { level: 'off', label: 'Stopped' },

	error: { level: 'problem', label: 'Error' },
};

const createServerStatus = (
	status: LWApiPublicAssetStatusT,
	powerStatus: AssetDetails['powerStatus'],
): StatusData => {
	switch (status) {
		case 'New':
			return serverStatusMap.new;
		case 'Pending-Activation':
			return serverStatusMap.activating;
		case 'Active':
			switch (powerStatus) {
				case 'on':
					return serverStatusMap.running;
				case 'off':
					return serverStatusMap.stopped;
				case 'start':
					return serverStatusMap.starting;
				case 'stop':
					return serverStatusMap.stopping;
				case 'shutdown':
					return serverStatusMap.shuttingDown;
				case 'reboot':
					return serverStatusMap.rebooting;
				case 'reset':
					return serverStatusMap.resetting;
				default:
					return serverStatusMap.active;
			}
		case 'Pending-Termination':
			return serverStatusMap.terminating;
		default:
			return serverStatusMap.error;
	}
};

export default createServerStatus;
